const utils = {
  isWeixin() {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
  },
  ua() {
    const ua = navigator.userAgent;
    const isIpad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const isIphone = !isIpad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
    const isAndroid = ua.match(/(Android)\s+([\d.]+)/);
    const isMobile = isIphone || isAndroid;
    return {
      isIpad,
      isIphone,
      isAndroid,
      isMobile,
    };
  },
  objectKeysIsEmpty(obj) {
    let empty = false;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === null || obj[key] === '') {
          empty = true;
        } else {
          empty = false;
          break;
        }
      }
    }
    return empty;
  },
  env() {
    let map = ['192.168', '127.0', 'localhost'];
    if (process.env.NODE_ENV === 'development') return 'development'; //开发环境
    map.forEach(item => {
      if (window.location.href.includes(item)) return 'development';
    });
    return 'production'; //线上环境
  },
  getStringLength(str = '') {
    let totalLength = 0,
      charCode;
    for (let i = 0, iLen = str.length; i < iLen; i++) {
      charCode = str.charCodeAt(i);
      if (charCode < 0x007f) {
        totalLength++;
      } else {
        totalLength += 2;
      }
    }
    return totalLength;
  },
  checkValidator(val, iLen) {
    if (this.getStringLength(val) > iLen) {
      return true;
    }
    return false;
  },
};

export default utils;
